var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 11H2C1.44772 11 1 11.4477 1 12C1 12.5523 1.44772 13 2 13H10.6971L7.44531 15.1678C7.10388 15.3954 6.93616 15.8085 7.02227 16.2097C7.10838 16.6109 7.43084 16.9188 7.8356 16.9863L11.9189 17.6668L10.2929 19.2928C9.90237 19.6833 9.90237 20.3165 10.2929 20.707C10.6834 21.0975 11.3166 21.0975 11.7071 20.707L14.7071 17.707C14.972 17.4421 15.0666 17.0514 14.9523 16.6947C14.838 16.338 14.5339 16.0751 14.1644 16.0135L10.6588 15.4292L14.3028 13H22C22.5523 13 23 12.5523 23 12C23 11.4477 22.5523 11 22 11H20C20 6.58172 16.4183 3 12 3C7.58172 3 4 6.58172 4 11ZM6 11C6 7.68629 8.68629 5 12 5C15.3137 5 18 7.68629 18 11H6Z",
    fill: "#FFC93E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunset);
export default __webpack_public_path__ + "static/media/sunset.65894fff61114b01cf5bbe89d7609a1f.svg";
export { ForwardRef as ReactComponent };